module.exports = __webpack_public_path__ + "static/media/mobileDown.b2019f3a.mp3";